"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DestroyElement = void 0;
class DestroyElement extends HTMLElement {
    constructor(destroyCallback) {
        super();
        this.callback = destroyCallback;
    }
    disconnectedCallback() {
        this.callback();
    }
}
exports.DestroyElement = DestroyElement;
window.customElements.define("destroy-el", DestroyElement);
